import React, { ReactNode } from 'react';
import { BaseContentBox, BaseContentBoxProps } from '@pokemon/design.ui.containers.base-content-box'
import './profile-overview.css'
import { useTranslation } from 'react-i18next'

export interface ProfileOverviewProps {
  /**
   * a node to be rendered in the special component.
   */
  children?: ReactNode

  /**
   * Uses the user's player ID for their account, if one has been made.
   */
  playerId?: string

  /**
   * Uses the user's birthday for their account.
   */
  birthday: string

  /**
   * Uses the user's region for their account.
   */
  region: string

  /**
   * Uses the user's email for their account.
   */
  email: string

  /**
   * Uses the Username or first and last name, depending on what's provided
   */
  name: string

  /**
   * The default size value for the box is 700 If you want a different size pass that value here
   */
  customWidth?: number

  /**
   * If passing a value of true the size of the component will adjust automatically for medium and small devices
   */
  autoSizeBox?: boolean
}

export function ProfileOverview({ children, playerId, birthday, region, email, name, customWidth, autoSizeBox, ...otherProps }: ProfileOverviewProps) {
  const { t } = useTranslation()
  let boxWidth
  if (customWidth) {
    boxWidth = customWidth
  } else {
    boxWidth = 700
  }

  return (
    <BaseContentBox customWidth={boxWidth} autoSizeBox={autoSizeBox} className='content-box-profile-overview' {...otherProps} >
      <div className='profileStyle'>
        <p className='profileId'> {playerId ? t('player_id', 'Player ID: ') + playerId : ''}</p>
        <h1 className='profileHeader'> {name} </h1>
        <ul className='profileList'>
          <li>
            <img className="icons" src="https://static.prod.pokemon.com/images/cake_icom.svg" alt='' />
            <div>
              {t('birthday', 'Birthday: ')}<br/>{birthday}
            </div>
          </li>
          <li>
            <img className="icons" src="https://static.prod.pokemon.com/images/globe_icon.svg" alt='' />
            <div>
              {t('region', 'Region: ')}<br/>{region}
            </div>
          </li>
          <li>
            <img className="icons" src="https://static.prod.pokemon.com/images/letter_icon.svg" alt='' />
            <div id="profile-overview-email-display">
              {t('email', 'Email: ')}<br />{email}
            </div>
          </li>
        </ul>
      </div>
    </BaseContentBox>
  );
}
